import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { APISalesforceUrl, APIDataUrl, APITokenUrl, GetUserId } from "../../Utils/Utils";
import Layout from "../../Components/Layout/Layout";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import Loader from "../../Components/Loader/Loader";
import ArchiveProspect from "../../Components/ArchivedTables/ArchivedProspect/ArchiveProspect";
import ArchivedOrganization from "../../Components/ArchivedTables/ArchivedOrganization/ArchivedOrganization";
import ProspectRequestModal from "../../Components/RequestUpdateModals/ProspectRequestModal";
import LeadsProspectModal from "../../Components/RequestUpdateModals/LeadsProspectModal";
import * as XLSX from 'xlsx';
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ClearIcon } from "@mui/x-date-pickers";

const Archived = () => {
    const [loading, setLoading] = React.useState(false);
    const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
    const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
    const [unArchivedRecord, setUnArchivedRecord] = useState(false)
    const [trackRecord, setTrackRecord] = useState(false)
    const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
    const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([])
    const [selectedProspects, setSelectedProspects] = useState([])
    const [selectedLeadsModal, setSelectedLeadsModal] = useState(false)
    const [selectedProspectsModal, setSelectedProspectsModal] = useState(false)
    const [showSalesForce, setShowSalesForce] = useState(false)
    const [showLeadsProspects, setShowLeadsProspects] = useState("")
    const [selectedProspectsInner, setSelectedProspectsInner] = React.useState([]);
       useEffect(() => {
        localStorage.removeItem("cns")
        localStorage.removeItem("cip")
        localStorage.removeItem("cdp")
    }, [])
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const [successModel, setSuccessModel] = React.useState("");


    const exportToExcel = (data, filename) => {
        const filteredData = data.map(
            ({ person_id, org_id, strengthData, ...rest }) => rest
        );
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `${filename}.xlsx`);
        setIsDecisionMakerExcel(false);
    };
    React.useEffect(() => {
        if (isDecisionMakerExcel) {
            if (selectedLeads?.length && selectedProspects?.length) {
                exportToExcel(selectedLeads, 'leads_exported_data');
                exportToExcel(selectedProspects, 'decisionmaker_exported_data');
            } else if (selectedLeads?.length && !selectedProspects?.length) {
                exportToExcel(selectedLeads, 'leads_exported_data');
            } else if (!selectedLeads?.length && selectedProspects?.length) {
                exportToExcel(selectedProspects, 'decisionmaker_exported_data');
            } else {
                toast.error("Please select records to download excel.")
            }
        }
        setIsDecisionMakerExcel(false)
    }, [isDecisionMakerExcel])
    useEffect(() => {
        if (selectedProspects?.length) {
            setShowLeadsProspects("pros")
        } else if (selectedLeads?.length || selectedProspectsInner?.length) {
            setShowLeadsProspects("leads")
        } else {
            setShowLeadsProspects("")
        }
    }, [selectedLeads, selectedProspects, selectedProspectsInner])
    useEffect(() => {
        if (unArchivedRecord === true) {
            if (!selectedLeads?.length && !selectedProspects?.length) {
                toast.error("Please select records to un-archive.")
            }
        }
        setUnArchivedRecord(false)
    }, [unArchivedRecord])
    useEffect(() => {
        if ((selectedLeads?.length + selectedProspects?.length) < 1 && requestUpdateRecord == true) {
            setDisableRequestUpdate(false)
            setRequestUpdateRecord(false)
            toast.error("Please select record to request update")
            return
        } else if ((selectedLeads?.length + selectedProspects?.length) === 1 && requestUpdateRecord == true) {
            if (selectedLeads?.length === 1) {
                setSelectedLeadsModal(true)
            } else {
                setSelectedProspectsModal(true)
            }
            setRequestUpdateRecord(false)
            setDisableRequestUpdate(false)
        } else if ((selectedLeads?.length + selectedProspects?.length) > 1) {
            setDisableRequestUpdate(true)
            setRequestUpdateRecord(false)
        } else {
            setDisableRequestUpdate(false)
        }
    }, [selectedLeads, selectedProspects, requestUpdateRecord])
    return (
        <>
            <Layout>
                {loading ? <Loader /> : null}
                <div className="child-section-of-everypage  ">

                    <AiLeadsAction
                        setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                        setIsSalesForceTrigger={setIsSalesForceTrigger}
                        isSalesForceTrigger={isSalesForceTrigger}
                        setUnArchivedRecord={setUnArchivedRecord}
                        setTrackRecord={setTrackRecord}
                        disableRequestUpdate={disableRequestUpdate}
                        setRequestUpdateRecord={setRequestUpdateRecord}
                        showSalesForce={showSalesForce}
                    />

                    {/* Archived Organization table  */}
                    <div style={{ display: "flex", width: "100%", zIndex: "999", padding: "50px 0px 10px 0px" }}> <p style={{ fontSize: "16px", fontWeight: "600" }}>Archived Organizations</p></div>

                    <ArchivedOrganization
                        isSalesForceTrigger={isSalesForceTrigger}
                        setIsSalesForceTrigger={setIsSalesForceTrigger}
                        isDecisionMakerExcel={isDecisionMakerExcel}
                        setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                        unArchivedRecord={unArchivedRecord}
                        setUnArchivedRecord={setUnArchivedRecord}
                        trackRecord={trackRecord}
                        setTrackRecord={setTrackRecord}
                        selectedOuterRows={selectedLeads}
                        setSelectedOuterRows={setSelectedLeads}
                        showLeadsProspects={showLeadsProspects}
                        selectedRows={selectedProspectsInner}
                        setSelectedRows={setSelectedProspectsInner}
                        setShowSalesForce={setShowSalesForce}
                    />

                    <div style={{ display: "flex", width: "100%", zIndex: "999", padding: "20px 0px 10px 0px" }}> <p style={{ fontSize: "16px", fontWeight: "600" }}>Archived Prospects</p></div>
                    <ArchiveProspect
                        isSalesForceTrigger={isSalesForceTrigger}
                        setIsSalesForceTrigger={setIsSalesForceTrigger}
                        isDecisionMakerExcel={isDecisionMakerExcel}
                        setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                        unArchivedRecord={unArchivedRecord}
                        setUnArchivedRecord={setUnArchivedRecord}
                        trackRecord={trackRecord}
                        setTrackRecord={setTrackRecord}
                        selectedOuterRows={selectedProspects}
                        setSelectedOuterRows={setSelectedProspects}
                        setShowSalesForce={setShowSalesForce}
                        showLeadsProspects={showLeadsProspects}
                    />
                </div>
            </Layout>
            <ProspectRequestModal requestUpdateRecord={selectedProspectsModal}
                setRequestUpdateRecord={setSelectedProspectsModal} profileData={selectedProspects[0]}
                peopleId={selectedProspects?.[0]?.id} setSelectedProspects={setSelectedProspects}
                setSelectedOuterRows={setSelectedProspects}
                setSuccessModel={setSuccessModel}
                successModel={successModel} />

            <LeadsProspectModal requestUpdateRecord={selectedLeadsModal}
                setSelectedOuterRows={setSelectedLeads}
                setRequestUpdateRecord={setSelectedLeadsModal} profileData={selectedLeads[0]}
                peopleId={selectedLeads?.[0]?.org_id} setSuccessModel={setSuccessModel}
                successModel={successModel} />

            <Modal
                open={successModel == true}
                onClose={() => setSuccessModel(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "30%", }}>
                        <div className='de_pad_req-up'>
                            <p className='cross-people-req-model'><ClearIcon onClick={() => setSuccessModel(false)} /></p>
                            <p className='de_head'>Your Record Update request has been successfully submitted. The Orbit Team will review your request and notify you when the record has been updated.</p>
                        </div>
                    </Box>
                </div>
            </Modal>

        </>
    );
};
export default Archived;